import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints"

// Upsert content library data
export const fetchProgressOverview  = async (payload) => {

    const {ClientId, ComponentName} = payload
    const response = await axiosInstance.get(`${Endpoints.GET_PROGRESS_OVERVIEW}/${ClientId}?ComponentName=${ComponentName}`);
    
    return response?.data;
  };